import React, { useEffect, useRef } from 'react';
import './style.scss';
import { useLocation } from "react-router-dom";
import { Page } from "../_partials/Layout";
import NavBar2 from "../../componets/NavBar2";

function Dashboard() {
  const PAGES: {[index: number]: any} = {
    1: {
      id: 1,
      name: 'Dashboard',
      icon: 'fa-solid fa-chart-pie',
      url: '/'
    },
    2: {
      id: 2,
      name: 'Status',
      icon: 'fa-regular fa-chart-bar',
      url: '/dashboard/status/hosts'
    },
    3: {
      id: 3,
      name: 'Analytics',
      icon: 'fa-solid fa-chart-line',
      url: '/dashboard/reports/analytics'
    },
    4: {
      id: 4,
      name: 'Uptime',
      icon: 'fa-regular fa-clock',
      url: '/dashboard/reports/uptime'
    },
    5: {
      id: 5,
      name: 'Events',
      icon: 'fa-regular fa-calendar',
      url: '/dashboard/reports/events'
    }
  };
  const PAGE_IDS = Object.keys(PAGES).map(id => parseInt(id, 10));
  const { pathname } = useLocation();
  const iframePath = pathname.replace('/dashboard', '');
  const pageId = PAGE_IDS.find(id => PAGES[id].url === pathname) || 1;
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (iframe && iframe.contentWindow) {
      const iframeDoc = iframe.contentWindow.document;
      const style = iframeDoc.createElement('style');
      style.textContent = `
      `;
      iframeDoc.head.appendChild(style);
    }
  }, []);

  return(
    <Page>
      <NavBar2 items={PAGES} itemIds={PAGE_IDS} activeId={pageId} />

      <div className='v-layout--body'>
        <iframe
          ref={iframeRef}
          className='v-monit-iframe'
          src={`https://monit.apps4you.tf${iframePath}`}
          width="100%"
        />
      </div>
    </Page>
  )
}

export default Dashboard;
